import { Link } from 'react-router-dom';

interface LegalLinksProps {
  variant?: 'footer' | 'inline';
  className?: string;
}

/**
 * Links discretos para Política de Privacidade e Termos de Uso.
 * Use no rodapé da tela de login, do perfil, e onde fizer sentido.
 */
export function LegalLinks({ variant = 'footer', className = '' }: LegalLinksProps) {
  const baseClass =
    variant === 'footer'
      ? 'flex flex-wrap items-center justify-center gap-3 text-[11px] text-slate-400'
      : 'flex flex-wrap items-center gap-3 text-xs text-slate-400';

  return (
    <div className={`${baseClass} ${className}`}>
      <Link
        to="/privacidade"
        className="hover:text-white transition-colors underline-offset-4 hover:underline"
      >
        Política de Privacidade
      </Link>
      <span aria-hidden="true">·</span>
      <Link
        to="/termos"
        className="hover:text-white transition-colors underline-offset-4 hover:underline"
      >
        Termos de Uso
      </Link>
    </div>
  );
}
